import { Card } from "@/shared/ui/card.tsx";
import { format, parse } from "date-fns";
import { useAtomValue } from "jotai";
import { SocialPostTypeWithFeedback } from "../types";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";
import { Heart } from "lucide-react";


type SocialCardWithImageProps = {
  content: SocialPostTypeWithFeedback,
}

const SocialCard = ({ content }: SocialCardWithImageProps) => {

  const theme = useAtomValue(themeAtom)

  return (
    <Card className="break-inside-avoid w-1/3 group relative mt-1 p-5 pb-3 flex flex-col justify-around gap-3 rounded-2xl">
      <div className="absolute top-1 right-2 flex items-center gap-2">
        <img src={`https://cdn.simpleicons.org/${(content.platform.toLowerCase().includes("twitter")) ? "x" : content.platform.toLowerCase()}`} className=" w-6 h-6" />
      </div>
      <div className="flex items-center gap-2">
        <img src={theme.avatar} className="w-7 aspect-square rounded-full" />
        <div className="flex items-center gap-2">
          <p className="text-sm flex items-center gap-2 font-semibold">{theme.handle}
            <img src="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9AcrbE4uO4h9zUp1a6MJqneWdFYX87yo52wmj" alt="" className="w-4" />
          </p>
          <p className="text-xs text-gray-400 font-poppins font-medium"> {format(parse(content.post_time, "HH:mm:ss", new Date()), "hh:mm a")} {" "}
            | {format(new Date(content.post_date), 'MMM dd, yyyy')}</p>
        </div>
      </div>
      <p className="text-xs lg:text-sm !leading-6 tracking-wide">{content.post_content} {content.tags.map((item) => `${item} `)} </p>
      <div className="pt-2 border-t flex items-center justify-end gap-1 px-2">
        <Heart size={16} />
      </div>
    </Card>
  )
}

export default SocialCard;
